module.exports = __webpack_public_path__ + "img/book-title.67feb632.png";